export const endPoints = {
    factoryDepartment: "factoryDepartment",
    createComplaint: "createComplaint",
    viewComplaint: "viewComplaint",
    updateComplaint: "updateComplaint",
    viewProduction: "viewProduction",
    createWhatsappBroadcast: "createWhatsappBroadcast",
    viewCategories: "viewCategories",
    viewWhatsappBroadcast: "viewWhatsappBroadcast",
    productionTank: "productionTank",
    viewProductionVisualizationDashboard : "viewProductionVisualizationDashboard",
    viewProductFolders : "viewProductFolders",
    viewRmQcSummaryReport : "viewRmQcSummaryReport",
    productionQcSummaryReport : "productionQcSummaryReport",
    viewFactoryProcessSummary : "viewFactoryProcessSummary",
    viewQcPermittedDeviation : "viewQcPermittedDeviation",
    viewPacking : "viewPacking",
    viewEmployees : 'viewEmployees',
    maintenance_plantLocation : 'maintenance_plantLocation',
    maintenance_functionalArea : 'maintenance_functionalArea',
    maintenance_machines : 'maintenance_machines',
    viewEmployeeAttendance : 'viewEmployeeAttendance',
    employeeAttendanceByDate: 'attendance-view/employee', // NEW
    downloadExcelReport: 'attendance-view/download-excel-report',
    viewUserType: 'viewUserType',
    packingSummaryExcelExport:'viewPacking/list/packingProcessSummaryReport/managers/excelExport',
    maintenance_employees: "maintenance_employees",
    entities: "entities",
    viewIndustryType: "viewIndustryType",
    paint_area: "paint_area",
    paint_type: "paint_type",
    rm_qc_cycle_time: "rm-qc_cycle_time",
    process_qc_cycle_time: "process-qc_cycle_time",
    rm_qc_technicians: "rm_qc_technicians",
    process_qc_technicians: "process_qc_technicians",
    viewRmQcControlChart: "viewRmQcControlChart",
    viewProductionQcControlChart: "viewProductionQcControlChart",
    viewProducts: "viewProducts",
    viewTestMethods: "viewTestMethods",
    factoryProductHistory: "factoryProductHistory",
    packing_employees: 'packing_employees',
    viewProductionQc: "viewProductionQc",
    viewRmQcById: "viewRmQc",
    viewGrnByInventoryId: "viewGrn/inventory_id",
    maintenance_machine_type: "maintenance_machine_type",
    viewCustomers: "viewCustomers", // customer dropdown
    updateInventoryTransfer: "updateInventoryTransfer",
    viewDepartments: "viewDepartments", 
    updateDepartments: "updateDepartments",
    factoryChecklistCreate: "factoryChecklist/create",
    factoryChecklistUpdate: "factoryChecklist/update",
    factoryChecklistView: "factoryChecklist/view",             
    request_for_maintenance: "request_for_maintenance",
    rm_transfer_weighing_access: "rm-transfer-weighing-access",
    createEmployeeAttendance: 'createEmployeeAttendance',
    updateEmployeeAttendance: 'updateEmployeeAttendance', 
    customer_survey_create: "FactoryCustomerSurvey/create",
    customer_survey_view: "FactoryCustomerSurvey/view",
    customer_survey_detail: "FactoryCustomerSurvey/detail",
    customer_survey_submit: "FactoryCustomerSurvey/submit",
    customer_survey_export: "FactoryCustomerSurvey/export",
    customer_survey_summary: "FactoryCustomerSurvey/summary",
    customer_survey_listing: "FactoryCustomerSurvey/view",
    customer_survey_update: "FactoryCustomerSurvey/update",
    customer_feedback_intake: "FactoryCustomerSurvey/view-feedback",
    customer_feedback_add:"FactoryCustomerSurvey/add-feedback",
    process_category_milling_access: "processCategoryMillingAccess",
    process_category_dropdown: "processCategory/view/list/dropdown",
    batch_posting_cycle_time: 'batch-posting-cycle-time', 
    kpi_assign_target: 'kpiReport/assign-target',
    kpi_report_download: 'kpiReport/report/download',
    batch_posting_summary_report: 'batchPostingSummaryReport',



    // customer_feedback_add:"FactoryCustomerSurvey/update",

    customer_survey_question: "FactoryCustomerSurvey/create-questionnaire"
            
}

// /viewRmQcSummaryReport?offset=0&limit=20&from_date=2025-07-01&to_date=2025-07-31